var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37109 12.8758H8.50009C8.78409 12.8758 9.05509 13.0044 9.24409 13.2288C9.43309 13.4531 9.52409 13.753 9.49409 14.0528L9.04509 18.4655L13.6291 11.1745H8.50009C8.21609 11.1745 7.94509 11.0458 7.75609 10.8215C7.56609 10.5971 7.47509 10.2973 7.50609 9.99745L7.95509 5.58585L3.37109 12.8758ZM7.61087 23.7212C7.49687 23.7212 7.38187 23.701 7.26887 23.6574C6.83687 23.4894 6.56687 23.0301 6.61687 22.5442L7.38587 15.0022H1.49987C1.13087 15.0022 0.791871 14.7864 0.617871 14.4408C0.443871 14.0942 0.463871 13.6742 0.668871 13.3478L8.55787 0.801987C8.81287 0.393683 9.29687 0.225683 9.72987 0.393683C10.1629 0.56062 10.4329 1.02102 10.3829 1.50695L9.61387 9.04781H15.4999C15.8689 9.04781 16.2079 9.26472 16.3819 9.61029C16.5559 9.95692 16.5359 10.3759 16.3309 10.7023L8.44187 23.2491C8.25287 23.5511 7.93687 23.7212 7.61087 23.7212Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.bdf99f70523a22ca5150fe863280791b.svg";
export { ForwardRef as ReactComponent };